<template>
  <permission-gate
    v-slot="{ canEdit }"
    moduleKey="suajes"
  >
    <main-breadcrumb
      :items="items"
      showBackButton
    ></main-breadcrumb>
    <main-buttons-bar :align="'space-between'">
      <template #left>
        <custom-title>Listado de suajes</custom-title>
      </template>
      <template #right>
        <el-tooltip
          v-if="!canEdit"
          content="El usuario no posee permisos de edición"
          placement="top"
        >
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            disabled
          >
            Nuevo Suaje
          </el-button>
        </el-tooltip>
        <template v-else>
          <el-button
            type="primary"
            size="default"
            :icon="IconAdd"
            style="margin-right: 50px"
            @click="openModal"
            >Nuevo Suaje</el-button
          >
          <modal-new-swage
            v-model="modalVisible"
            @closed="handleModalClosed"
          ></modal-new-swage>
        </template>
      </template>
    </main-buttons-bar>
    <swage-filter></swage-filter>
    <custom-table
      :requestApi="findAllSuajesHTTP"
      :requestArgs="swageFilters"
      :pathEdit="'/page/swage/edit'"
      :pathDetail="'/page/swage/detail'"
      :paramId="'Codigo'"
      :data="swagesList"
      :columns="columns"
      :fixedActions="'right'"
    ></custom-table>
  </permission-gate>
</template>

<script setup>
import {
  ref,
  onBeforeMount,
} from 'vue';
import { storeToRefs } from 'pinia';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import CustomTable from '@/shared/components/custom_table.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import IconAdd from '~icons/mdi/add';
import ModalNewSwage from './modal_new_swage.vue';
import { useMaterialStore } from '@/stores/materiales_store.js';
import { useSwageStore } from '@/stores/swage_store.js';
import SwageFilter from './swage_filter.vue';
import PermissionGate from '@/shared/components/permission_gate.vue';

const swageStore = useSwageStore();
const materialStore = useMaterialStore();
const { swageFilters } = storeToRefs(swageStore);
const { findAllSuajesHTTP, firstSwage, resetFilter, findAllClaseSuajeHTTP } = swageStore;
const { swagesList } = storeToRefs(swageStore);
const { findAllMaterialesByTipoHTTP } = materialStore;

const items = [
  { label: 'Inicio', to: '/dashboard', replace: false },
  { label: 'Listado', to: null, replace: false },
];

const columns = [
  { field: 'Codigo', label: 'id', width: 120, sortable: true, isVisible: false },
  { field: 'CodigoSuaje', label: 'Codigo suaje', width: 120, sortable: true, isVisible: true },
  {
    field: 'CodigoAdicional',
    label: 'Código adicional',
    width: 150,
    sortable: true,
    isVisible: true,
  },
  { field: 'MedidaEjeMm', label: 'Medida Eje Mm', width: 140, sortable: true, isVisible: true },
  {
    field: 'MedidaDesarrolloMm',
    label: 'Medida Des. Mm',
    width: 140,
    sortable: true,
    isVisible: true,
  },
  { field: 'GapEjeMm', label: 'Gap al Eje Mm', width: 120, sortable: true, isVisible: true },
  { field: 'GapDesarrolloMm', label: 'Gap Des. Mm', width: 120, sortable: true, isVisible: true },
  { field: 'EtiquetasEje', label: 'Etiquetas Eje', width: 110, sortable: true, isVisible: true },
  {
    field: 'EtiquetasDesarrollo',
    label: 'Etiquetas Des.',
    width: 120,
    sortable: true,
    isVisible: true,
  },
  { field: 'AnchoOptimoMaterial', label: 'Ancho', width: 80, sortable: true, isVisible: true },
  { field: 'Engranaje', label: 'Engranaje', width: 100, sortable: true, isVisible: true },
  { field: 'TienePleca', label: 'Pleca', width: 80, sortable: true, isVisible: true },
  { field: 'EsAutomatica', label: 'Automática', width: 120, sortable: true, isVisible: true },
  {
    field: 'EsCorteCompleto',
    label: 'Corte completo',
    width: 150,
    sortable: true,
    isVisible: true,
  },
  {
    field: 'MinEtiquetaImpresa',
    label: 'Min etiqueta impresa',
    width: 200,
    sortable: true,
    isVisible: true,
  },
  {
    field: 'MinEtiquetaSinImpresion',
    label: 'Min etiqueta sin impresion',
    width: 200,
    sortable: true,
    isVisible: true,
  },
  { field: 'Material', label: 'iItem', width: 280, sortable: true, isVisible: true },
  { field: 'Descripcion', label: 'Descripción', width: 320, sortable: true, isVisible: true },
  { field: 'Observaciones', label: 'Observaciones', width: 250, sortable: true, isVisible: true },
];

const modalVisible = ref(false);

const openModal = () => {
  modalVisible.value = true;
};

const handleModalClosed = () => {
  // Acciones a realizar cuando se cierra el modal
  modalVisible.value = false;
};
onBeforeMount(async () => {
  findAllMaterialesByTipoHTTP();
  resetFilter();
  await findAllClaseSuajeHTTP();
  await firstSwage();
});
</script>

<style scoped></style>
